import React, { FC } from 'react'

type C01LogoProps = Record<string, unknown>

const C01Logo: FC<C01LogoProps> = () => {
  return (
    <svg width="100px" height="100px" fill="none">
      <mask
        id="a"
        style={{
          maskType: 'alpha'
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={100}
        height={100}
      >
        <path
          d="M0 34.883C0 22.544 0 16.375 2.44 11.68a21.667 21.667 0 0 1 9.239-9.24C16.375 0 22.544 0 34.883 0h30.234C77.456 0 83.625 0 88.32 2.44a21.666 21.666 0 0 1 9.24 9.239C100 16.375 100 22.544 100 34.883v30.234c0 12.339 0 18.508-2.44 23.204a21.666 21.666 0 0 1-9.239 9.24C83.625 100 77.456 100 65.117 100H34.883c-12.339 0-18.508 0-23.204-2.44a21.666 21.666 0 0 1-9.24-9.239C0 83.625 0 77.456 0 65.117V34.883Z"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#a)">
        <path fill="#F18D8D" d="M0 0h100v100H0z" />
        <path fill="#fff" d="M0 0h100v100H0z" />
        <g opacity={0.4}>
          <mask
            id="b"
            style={{
              maskType: 'alpha'
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={100}
            height={100}
          >
            <path fill="#fff" d="M0 0h100v100H0z" />
          </mask>
          <g mask="url(#b)">
            <path
              opacity={0.5}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M68.962 88.726a43.33 43.33 0 0 0 11.371-8.1l12.502 12.502H68.962v-4.402Zm-18.75 4.402v-.005a42.857 42.857 0 0 0 18.334-4.192v4.197H50.212Zm-18.75 0V88.93a42.857 42.857 0 0 0 18.334 4.192v.005H31.462Zm-24.288 0 12.5-12.502a43.344 43.344 0 0 0 11.372 8.1v4.402H7.174Zm4.107-24.167a43.33 43.33 0 0 0 8.1 11.371L6.879 92.834V68.96h4.402Zm-4.402-18.75h.005a42.854 42.854 0 0 0 4.192 18.334H6.879V50.21Zm0-18.75h4.197a42.856 42.856 0 0 0-4.192 18.333h-.005V31.461Zm0-24.288 12.502 12.5a43.343 43.343 0 0 0-8.1 11.372H6.879V7.172Zm24.167 4.107a43.344 43.344 0 0 0-11.371 8.1L7.174 6.877h23.872v4.402Zm18.75-4.402v.005a42.869 42.869 0 0 0-18.334 4.192V6.878h18.334Zm18.75 0v4.197a42.869 42.869 0 0 0-18.334-4.192v-.005h18.334Zm24.289 0L80.333 19.38a43.33 43.33 0 0 0-11.37-8.1V6.878h23.872Zm-4.108 24.166a43.324 43.324 0 0 0-8.099-11.37l12.5-12.501v23.871h-4.4Zm4.402 18.75h-.005a42.856 42.856 0 0 0-4.19-18.333h4.195v18.333Zm0 18.75h-4.196a42.854 42.854 0 0 0 4.191-18.333h.005v18.334Zm-23.872.417H88.26a42.88 42.88 0 0 1-7.926 11.076L69.257 68.961Zm-.295.294L80.04 80.332a42.918 42.918 0 0 1-11.077 7.926V69.255Zm-18.75 7.618c7.103-.055 13.554-2.88 18.334-7.444v19.043a42.448 42.448 0 0 1-18.334 4.234V76.873Zm-18.75-7.444c4.78 4.565 11.231 7.389 18.334 7.444v15.833a42.448 42.448 0 0 1-18.334-4.234V69.43Zm-.416-.173v19.002a42.913 42.913 0 0 1-11.076-7.926l11.076-11.076Zm-.295-.295L19.675 80.037a42.898 42.898 0 0 1-7.926-11.076H30.75Zm-7.617-18.75c.055 7.103 2.88 13.553 7.443 18.334H11.535A42.447 42.447 0 0 1 7.3 50.21h15.833Zm7.443-18.75c-4.564 4.78-7.388 11.23-7.443 18.333H7.3a42.436 42.436 0 0 1 4.235-18.333h19.041Zm.174-.416H11.75a42.912 42.912 0 0 1 7.926-11.076L30.75 31.044Zm.295-.296L19.97 19.674a42.915 42.915 0 0 1 11.076-7.926v19.001Zm18.75-7.616c-7.103.055-13.554 2.879-18.334 7.443V11.534A42.436 42.436 0 0 1 49.796 7.3v15.834Zm18.75 7.443c-4.78-4.564-11.231-7.388-18.334-7.443V7.299a42.436 42.436 0 0 1 18.334 4.235v19.042Zm.416.174V11.748a42.918 42.918 0 0 1 11.077 7.926L68.962 30.75Zm.295.294L80.333 19.97a42.912 42.912 0 0 1 7.926 11.075H69.257Zm7.617 18.75c-.054-7.102-2.88-13.553-7.443-18.333h19.042a42.448 42.448 0 0 1 4.234 18.333H76.874Zm0 .417h15.833a42.448 42.448 0 0 1-4.234 18.334H69.431c4.564-4.78 7.389-11.231 7.443-18.334Zm-26.662 18.75h18.221c-4.722 4.592-11.143 7.44-18.22 7.495v-7.495Zm-.416 0v7.495c-7.078-.055-13.5-2.903-18.221-7.495h18.22Zm-18.75-18.75v18.221c-4.591-4.722-7.44-11.143-7.495-18.22h7.495Zm0-.416H23.55c.056-7.078 2.904-13.5 7.495-18.221v18.22Zm18.75-18.75H31.575c4.722-4.591 11.143-7.44 18.22-7.496v7.495Zm.416 0v-7.496c7.078.056 13.5 2.905 18.221 7.495h-18.22Zm18.75 18.75V31.573c4.592 4.721 7.44 11.143 7.495 18.22h-7.495Zm0 .416h7.495c-.055 7.078-2.903 13.5-7.495 18.222V50.21Zm-18.75.294 18.04 18.04h-18.04v-18.04Zm-.416.001v18.038H31.757l18.039-18.038Zm-.294-.295-18.04 18.04V50.21h18.04Zm0-.416h-18.04v-18.04l18.04 18.04Zm.294-.296L31.757 31.461h18.039V49.5Zm.416.001V31.461h18.04l-18.04 18.04Zm18.334.711V68.25L50.507 50.212h18.039Zm-18.039-.416 18.039-18.039v18.038H50.507ZM93.13 92.834l-12.5-12.502a43.31 43.31 0 0 0 8.098-11.37h4.402v23.872Zm8.003 8.002-7.291-7.291h6.371v-.417h-6.666V68.96h6.666v-.416h-6.666V50.21h6.666v-.416h-6.666V31.46h6.666v-.416h-6.666V6.877h6.666V6.46h-6.371l6.458-6.458-.295-.294-6.458 6.458V-.206h-.417v6.667H68.962V-.206h-.416v6.667H50.212V-.206h-.416v6.667H31.462V-.206h-.416v6.667H6.879V-.206h-.417v6.373L.004-.291l-.295.294 6.46 6.458H-.205v.417h6.666v24.166H-.204v.417h6.666v18.334H-.204v.416h6.666v18.334H-.204v.416h6.666v24.167H-.204v.416h6.372l-6.459 6.459.295.295 6.458-6.459v6.372h.417v-6.666h24.167v6.666h.416v-6.666h18.334v6.666h.416v-6.666h18.334v6.666h.416v-6.666H93.13v6.666h.417V93.84l7.291 7.291.295-.295Z"
              fill="#fff"
            />
          </g>
        </g>
        <g opacity={0.4} stroke="#fff" strokeWidth={0.195}>
          <rect
            opacity={0.72}
            x={16.895}
            y={4.395}
            width={66.406}
            height={91.406}
            rx={6.934}
          />
          <rect
            opacity={0.72}
            x={10.645}
            y={10.645}
            width={78.906}
            height={78.906}
            rx={6.934}
          />
          <rect
            opacity={0.72}
            x={4.395}
            y={16.895}
            width={91.406}
            height={66.406}
            rx={6.934}
          />
          <path d="M95.8 50.098C95.8 75.338 75.34 95.8 50.099 95.8S4.395 75.339 4.395 50.098c0-25.241 20.462-45.703 45.703-45.703 25.24 0 45.703 20.462 45.703 45.703Z" />
          <path d="M70.606 50.098c0 11.326-9.182 20.508-20.508 20.508-11.326 0-20.508-9.182-20.508-20.508 0-11.326 9.182-20.508 20.508-20.508 11.326 0 20.508 9.182 20.508 20.508Z" />
          <path d="M35.645 35.645h28.906v28.906H35.645z" />
          <path
            d="M35.645.098v100M50.098 0v100M64.55 0v100M100.098 35.645h-100M100 50.098H0M100.098 64.55h-100M.098.098l100 100M100.098.098l-100 100"
            strokeLinecap="square"
          />
        </g>
        <circle cx={50} cy={50.391} r={43.75} fill="#75FABF" />
        <circle cx={49.98} cy={50.176} r={28.887} fill="#000" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M70.385 50.177c0 8.76-7.108 15.86-15.876 15.86s-15.876-7.1-15.876-15.86 7.108-15.86 15.876-15.86 15.876 7.1 15.876 15.86Z"
          fill="#75FABF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.489 42.733c2.538-4.76 7.43-8.073 13.124-8.39a4.196 4.196 0 0 0-.462-.027H39.03a4.21 4.21 0 0 0-4.213 4.209 4.21 4.21 0 0 0 4.213 4.208h1.458Z"
          fill="#42DBA1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.614 34.344c-5.694.316-10.587 3.63-13.124 8.389h12.662a4.21 4.21 0 0 0 4.212-4.208 4.209 4.209 0 0 0-3.75-4.181Z"
          fill="#00A673"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.633 50.177c0-1.457.2-2.867.569-4.208h-5.935a4.21 4.21 0 0 0-4.212 4.208 4.21 4.21 0 0 0 4.212 4.208h5.935a15.85 15.85 0 0 1-.57-4.208Z"
          fill="#42DBA1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.327 45.97h-3.125a15.852 15.852 0 0 0 0 8.415h3.125a4.21 4.21 0 0 0 4.212-4.208 4.21 4.21 0 0 0-4.212-4.208Z"
          fill="#00A673"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.489 57.622h-1.458a4.21 4.21 0 0 0-4.213 4.208 4.21 4.21 0 0 0 4.213 4.208h14.12c.156 0 .31-.01.462-.027-5.694-.316-10.586-3.63-13.124-8.39Z"
          fill="#42DBA1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.152 57.622H40.49c2.537 4.759 7.43 8.073 13.124 8.389a4.209 4.209 0 0 0 3.75-4.181 4.21 4.21 0 0 0-4.212-4.208Z"
          fill="#00A673"
        />
        <path
          d="M.833 34.883c0-6.183.001-10.77.302-14.399.301-3.62.896-6.212 2.044-8.421a20.834 20.834 0 0 1 8.884-8.884c2.21-1.148 4.802-1.743 8.421-2.044 3.63-.301 8.216-.302 14.4-.302h30.233c6.183 0 10.77.001 14.399.302 3.62.301 6.212.896 8.421 2.044a20.834 20.834 0 0 1 8.884 8.884c1.148 2.21 1.743 4.802 2.044 8.421.301 3.63.302 8.216.302 14.4v30.233c0 6.183-.001 10.77-.302 14.399-.301 3.62-.896 6.212-2.044 8.421a20.834 20.834 0 0 1-8.884 8.884c-2.21 1.148-4.802 1.743-8.421 2.044-3.63.301-8.216.302-14.4.302H34.884c-6.183 0-10.77-.001-14.399-.302-3.62-.301-6.212-.896-8.421-2.044a20.834 20.834 0 0 1-8.884-8.884c-1.148-2.21-1.743-4.802-2.044-8.421-.301-3.63-.302-8.216-.302-14.4V34.884Z"
          stroke="#E6E6E6"
          strokeWidth={1.667}
        />
      </g>
    </svg>
  )
}

export default C01Logo
